import React from 'react';
import PropTypes from 'prop-types';

import { DateControls } from 'components/DateControls';
import { useIsScheduleCalendarV2Enabled } from 'hooks/useIsScheduleCalendarV2Enabled';

import ScheduleCalendarControl from './ScheduleCalendarControl';

const ScheduleDateControl = ({ setDate, venueId }) => {
  const isScheduleCalendarV2Enabled = useIsScheduleCalendarV2Enabled(venueId);

  return isScheduleCalendarV2Enabled === true ? (
    <ScheduleCalendarControl setDate={setDate} />
  ) : (
    <DateControls setDate={setDate} isControl />
  );
};

ScheduleDateControl.propTypes = {
  setDate: PropTypes.func,
  venueId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ScheduleDateControl;
